import { useCallback, useEffect, useState } from 'react'
import { api, ApiRoutes } from '../services/ApiService'
import * as yup from 'yup'
import { AnyObject } from 'yup'

export const useStoreData = <DataType extends object>(
    url: ApiRoutes,
    validation: AnyObject
) => {
    const [element, setElement] = useState<Partial<DataType>>({})
    const [files, setFiles] = useState<File[]>([])
    const [isLoading, setIsLoading] = useState<boolean>(true)
    const [isValid, setIsValid] = useState<boolean>(false)
    const [error, setError] = useState<string | null>(null)

    const changeProp = useCallback((data: Partial<DataType>) => {
        setElement((prevElement) => ({ ...prevElement, ...data }))
    }, [])

    const addFile = (file: File) => {
        setFiles((prevFiles) => [...prevFiles, file])
    }

    const changeFile = (file: File) => {
        setFiles([file])
    }

    const clearData = () => {
        setFiles([])
        setElement({})
    }

    useEffect(() => {
        yup.object(validation)
            .validate(element)
            .then(() => {
                setError(null)
                setIsValid(true)
            })
            .catch((reason) => {
                setError(reason)
                setIsValid(false)
            })
    }, [element, validation])

    const submit = async () => {
        setIsLoading(true)

        const response = await api.post(url, undefined, element, files)
        setIsLoading(false)

        return response
    }

    return {
        error,
        element,
        isValid,
        isLoading,
        files,
        changeProp,
        clearData,
        addFile,
        changeFile,
        submit,
    }
}
